import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface VersionInfo {
  id: string;
  name: string;
  created_at: string;
  modified_at: string;
  created_by: string;
  analysis_started_at?: string | null;
  analysis_ended_at?: string | null;
  analysis_duration_seconds?: number | null;
}

export interface ProjectVersionsResponse {
  project_id: string;
  versions: VersionInfo[];
}

export interface VersionDataResponse {
  id: string;
  name: string;
  data: {
    overview?: any;
    [key: string]: any; // All tabs data
  };
  project_id: string;
  filters?: {
    country?: string;
    brands?: string[];
    competitors?: string[];
    category?: string;
    industry?: string;
    [key: string]: any;
  };
  created_at: string;
  modified_at: string;
  created_by: string;
  modified_by: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectHistoryService {
  private apiUrl = environment.apiUrl + '/generic';

  constructor(private http: HttpClient) {}

  /**
   * Get all versions for a project (metadata only, no data field)
   */
  getProjectVersions(projectId: string): Observable<ProjectVersionsResponse> {
    return this.http.get<ProjectVersionsResponse>(
      `${this.apiUrl}/history/project/${projectId}`
    );
  }

  /**
   * Get specific version data (full JSON with all tabs)
   */
  getVersionData(versionId: string): Observable<VersionDataResponse> {
    return this.http.get<VersionDataResponse>(
      `${this.apiUrl}/history/${versionId}`
    );
  }

  /**
   * Delete a version
   */
  deleteVersion(versionId: string): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}/history/${versionId}`
    );
  }

  /**
   * Update version data (typically called automatically by query-frontend)
   */
  updateVersion(versionId: string, data: any): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/history/${versionId}`,
      { data }
    );
  }
}

